import { analytics, configure } from 'instantsearch.js/es/widgets';

const skip_analytics = MWC_AIS.skip_analytics === '1';

if ( skip_analytics ) {
	configure( { clickAnalytics: false } );
} else {
	configure( { clickAnalytics: true } );
}

export const analyticsWidget = ( search ) => {
	if ( skip_analytics ) {
		return;
	}

	search.addWidgets( [
		analytics( {
			pushFunction( formattedParameters, state, results ) {
				window.dataLayer.push( {
					event: 'algoliasearcher',
					'Search Query': state.query,
					'Facet Parameters': formattedParameters,
					'Number of Hits': results.nbHits,
				} );
			},
		} ),
	] );
};
